import React from 'react';
import { Result } from 'antd';

export enum PanelResultStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  NOT_FOUND = '404',
}

interface PanelResultProps {
  extra?: React.ReactNode;
  status?: PanelResultStatus;
  title: String | React.ReactNode;
  subtitle?: String | React.ReactNode;
};

export const PanelResult = ({
  extra,
  status = PanelResultStatus.SUCCESS,
  subtitle,
  title,
}: PanelResultProps) => (
  <Result status={status} title={title} subTitle={subtitle} extra={extra} />
);
